export default "__VITE_PUBLIC_ASSET__ee7520e9__"